// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"406":"81e06cd4","527":"e084ecdd"}[chunkId] + ".chunk.js");